import { useQuery } from '@tanstack/react-query';
import { getClientStats, getSubscriptionStats, getSupplierStats } from '../lib/entityStatsApi';

// Financial stats per entity — one query per detail page, keyed on the id.

export function useSubscriptionStats(id: string | undefined) {
  return useQuery({
    queryKey: ['subscriptions', 'stats', id],
    queryFn: () => getSubscriptionStats(id as string),
    enabled: Boolean(id),
  });
}

export function useSupplierStats(id: string | undefined) {
  return useQuery({
    queryKey: ['suppliers', 'stats', id],
    queryFn: () => getSupplierStats(id as string),
    enabled: Boolean(id),
  });
}

export function useClientStats(id: string | undefined) {
  return useQuery({
    queryKey: ['clients', 'stats', id],
    queryFn: () => getClientStats(id as string),
    enabled: Boolean(id),
  });
}
